import request from '@/plugins/admin_axios'

export const TransferirAtendimentoFilialApi = async (data) => {
  const response = await request.post('/atendimento/transferir/filial/', data)
  return response.data
}


export const TransferirAtendimentoUsuarioApi = async (data) => {
  const response = await request.post('atendimento/transferir/usuario/', data)
  return response.data
}

export const UpdateStatusAtendimentoApi = async (atendimentoUuid, data) => {
  const response = await request.put(`atendimento/updateStatus/${atendimentoUuid}`, data)
  return response.data
}

export const FinalizarAtendimentoApi = async (atendimentoUuid, data) => {
  const response = await request.post(`atendimento/finalizar/${atendimentoUuid}`, data)
  return response.data
}

export const GoBackStatusAtendimentoApi = async (atendimentoUuid, data) => {
  const response = await request.put(`atendimento/back-status/${atendimentoUuid}`, data)
  return response.data
}

export const ListAtendimentosApi = async (filters = {}) => {
  const response = await request.get('/atendimento/listAtendimentos/', { params: filters })
  return response.data
}

export const GetRecuperacao = async (data_inicial, data_final, filial_array, closed = null, flag_uuid = null) => {
  return await request.post('/atendimento/recuperacao/list/', {
    data_inicial: data_inicial,
    data_final: data_final,
    filial_uuids: filial_array,
    closed: closed,
    flag_uuid: flag_uuid
  })

}

export const ListMeusAtendimentosIniciadosApi = async (query_params = {}) => {
  return await request.get('/atendimento/list/meus-atendimentos-iniciados/', { params: query_params })
}

export const ListMeusAtendimentosFinalizadosApi = async (query_params = {}) => {
  return await request.get('/atendimento/list/meus-atendimentos-finalizados/', { params: query_params })
}

export const ListAtendimentosEmAndamentoApi = async () => {
  const response = await request.get('/atendimento/list/em-andamento/')
  return response.data
}

export const RetornarAtendimentoFilaVideoApi = async (atendimento_uuid, data = {}) => {
  return await request.put(`/atendimento/return_queue/${atendimento_uuid}`, data)
}

export const RemoverAgrFilaVideoApi = async (user_uuid) => {
  const response = await request.post('filas/fila_agrs/out/', { user_uuid: user_uuid })
  return response.data
}

export const GetMinhaProdutividadeApi = async (params) => {
  return await request.get('/atendimento/minha-produtividade/', { params })
}
